import FormContainer from "src/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { useEffect } from "react";
import { InspectorProps } from "@app/components/WidgetStudio/Inspector/contracts/InspectorProps";
import { FunctionsSchema } from "@app/components/WidgetStudio/Inspector/schemas/functions";
import { WidgetStudioDataType } from "@app/components/WidgetStudio/Inspector/schemas/widgetStudioData";

export interface FunctionsInspectorProps extends InspectorProps {}

export const FunctionsInspector = ({
  onValueChange,
  defaultFormValues,
}: FunctionsInspectorProps) => {
  const { form, schemas, zodSchema, parseForm, formValues } =
    useFormWithSchema<WidgetStudioDataType>({
      formSchemas: FunctionsSchema,
      defaultFormValues,
      mode: "onChange",
    });

  useEffect(() => {
    onValueChange(formValues);
  }, [formValues]);

  return (
    <div className="flex flex-col">
      <FormContainer schemas={schemas} form={form} />
    </div>
  );
};
